export { default } from '@flamingo_tech/funkgo-utils/classNameUtils'

